import { render, staticRenderFns } from "./LandingPageInfo.vue?vue&type=template&id=a147a9e4&scoped=true&"
import script from "./LandingPageInfo.vue?vue&type=script&lang=js&"
export * from "./LandingPageInfo.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageInfo.vue?vue&type=style&index=0&id=a147a9e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a147a9e4",
  null
  
)

export default component.exports